import PageTemplate from './PageTemplate';
import './ModulePage.css';

function Analytics() {
  return (
    <PageTemplate title="Analytics" subtitle="Reports and platform insights">
      <div className="module-placeholder">
        <div className="module-actions">
          <input type="search" placeholder="Search analytics..." className="search-input" />
          <button className="btn-primary">Export Report</button>
        </div>
        <div className="placeholder-table">
          <p>Analytics dashboard will be implemented here.</p>
          <ul>
            <li>Student progress analytics</li>
            <li>Course revenue analytics</li>
            <li>Engagement metrics</li>
            <li>Charts and visualizations</li>
          </ul>
        </div>
      </div>
    </PageTemplate>
  );
}

export default Analytics;
